import { render, staticRenderFns } from "./GrowerReportView.vue?vue&type=template&id=28a68daa&scoped=true"
import script from "./GrowerReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./GrowerReportView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GrowerReportView.vue?vue&type=style&index=0&id=28a68daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a68daa",
  null
  
)

export default component.exports